const dateTimeFmt = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
})

export function formatDateTime(iso: string | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return dateTimeFmt.format(d)
}

export function formatDurationSec(totalSeconds: number): string {
  const s = Math.max(0, Math.round(totalSeconds))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  if (h > 0) return `${h}ч ${m}м`
  if (m > 0) return `${m}м ${s % 60}с`
  return `${s}с`
}

/**
 * Сколько прошло с момента. Момент времени и его возраст отвечают на разные
 * вопросы: «когда завелось» ищут в журнале, «сколько висит» решает, срочно ли
 * это, — поэтому подпись несёт оба, а не одно.
 */
export function formatAgo(iso: string | undefined, now: number = Date.now()): string {
  if (!iso) return '—'
  const at = Date.parse(iso)
  if (Number.isNaN(at)) return '—'
  const sec = Math.round((now - at) / 1000)
  if (sec < 0) return 'в будущем'
  if (sec < 60) return 'только что'
  return `${formatDurationSec(sec)} назад`
}

// Таймер-формат для звонков: 03:27 / 1:02:11.
export function formatClock(ms: number): string {
  const s = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  const mm = String(m).padStart(2, '0')
  const ss = String(sec).padStart(2, '0')
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`
}

// Положение на оси звонка: 1:02.4 — десятые доли нужны, латентность ходов
// меряется сотнями мс.
export function formatTimecode(ms: number): string {
  const total = Math.max(0, ms)
  const m = Math.floor(total / 60_000)
  const s = Math.floor((total % 60_000) / 1000)
  const tenth = Math.floor((total % 1000) / 100)
  return `${m}:${String(s).padStart(2, '0')}.${tenth}`
}

export function formatMoneyCents(cents: number, currency: string): string {
  const code = currency ? currency.toUpperCase() : 'USD'
  try {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: code,
      maximumFractionDigits: 2,
    }).format(cents / 100)
  } catch {
    return `${(cents / 100).toFixed(2)} ${code}`
  }
}
